import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BreakpointService {
  // Define the Bootstrap breakpoints
  breakpoints = {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1400,
  };

  // Observable to notify when the breakpoint changes
  private readonly currentBreakpoint = new BehaviorSubject<string>('xs');
  currentBreakpoint$ = this.currentBreakpoint.asObservable();

  constructor() {
    this.checkBreakpoint();
    window.addEventListener('resize', () => this.checkBreakpoint());
  }

  checkBreakpoint() {
    const width = window.innerWidth;
    let breakpoint = 'xs';

    if (width >= this.breakpoints.xxl) {
      breakpoint = 'xxl';
    } else if (width >= this.breakpoints.xl) {
      breakpoint = 'xl';
    } else if (width >= this.breakpoints.lg) {
      breakpoint = 'lg';
    } else if (width >= this.breakpoints.md) {
      breakpoint = 'md';
    } else if (width >= this.breakpoints.sm) {
      breakpoint = 'sm';
    }

    this.currentBreakpoint.next(breakpoint);
  }
}
